<template>
  <van-popup
    :value="value"
    position="bottom"
    class="rule-wrap"
    @click-overlay="closePopup"
    @click-close-icon="closePopup"
  >
    <div class="rule-content-wrap">
      <van-icon
        name="cross"
        class="close-icon"
        color="rgb(204, 204, 204)"
        @click="closePopup"
      />
      <div class="rule-title">会员开通规则</div>
      <div class="rule-content">
        <p>
          1、凡在本页面成功开通会员，可享首月1元优惠价格，次月起按9.9元/月自动续费，可随时取消，取消续费后不再享受会员权益。
        </p>
        <p>
          2、每日优惠会员卡数量有限，送完即止，如当日已达上限无法购买，可次日重试。
        </p>
        <p>
          3、橡树超级省钱卡月卡支持重复购买，各会员卡权益可独立使用，互不影响。
        </p>
        <p>
          4、支付成功后，可返回当前页面或前往【橡树黑卡】公众号登录个人手机号享受会员权益。
        </p>
        <p>
          5、该会员解释权由深圳市橡树黑卡网络科技有限公司所有。若有任何疑问，请拨打客服热线：400-150-9669，服务时间：周一至周日，08:00-20:00。
        </p>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: ["value", "update"],
  setup(props, { emit }) {
    const closePopup = () => {
      emit("update:value", false);
    };

    return {
      closePopup,
    };
  },
});
</script>


<style lang="less" scoped>
.rule-wrap {
  width: 375px;
  height: 350px;
  background: linear-gradient(180deg, #ffecd5 0%, #ffffff 30%), #ffffff;
  border-radius: 16px 16px 0px 0px;

  .close-icon {
    top: 10px;
    right: 10px;
    position: absolute;
  }
}

.rule-content-wrap {
  position: relative;
  padding: 16px 14px;

  .close-icon {
    top: 10px;
    right: 10px;
    font-size: 14px;
    position: absolute;
    font-weight: 600;
  }

  .rule-title {
    font-weight: 600;
    font-size: 18px;
    color: #222222;
    text-align: center;
  }

  .rule-content {
    margin-top: 19px;

    > p {
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 17px;
      text-align: left;
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }
}
</style>